import { useState } from "react";

// import mysoreImg from "../assets/mysore.jpg";
// import mainImg from "../assets/main.jpg";
// import lakeImg from "../assets/lake.jpg";
// import hegdeImg from "../assets/hegde.jpg";

import mysoreImg from "../assets/image/cps 001.jpg";
import mainImg from "../assets/image/6.jpeg";
import lakeImg from "../assets/image/7.jpeg";
import hegdeImg from "../assets/image/8.jpeg";

function ContactSection() {
  const [active, setActive] = useState(0);

  const branches = [
    {
      name: "Mysore Branch",
      image: mysoreImg,
      content: (
        <>
          <p>2899, Pampapathi Main Road, Saraswathipuram, Mysuru - 570009</p>
          <p className="mt-2">
            <strong>Ph:</strong> 8970745451, 8197383334, 0821-4000681
          </p>
          <p className="mt-2">
            <strong>Email:</strong> capitolmysuru@gmail.com
          </p>
        </>
      ),
    },
    {
      name: "Capitol Public School",
      image: mainImg,
      content: (
        <>
          <p>
            No:1, 9th Cross, RBI Layout, J.P Nagar 7th Phase, Bangalore - 560078
          </p>
          <p className="mt-2">
            <strong>Ph:</strong> 26851095, 26851104
          </p>
          <p className="mt-2">
            <strong>Email:</strong> capitolinstitutions@yahoo.co.in
          </p>
          <p className="mt-2">
            <strong>Contact Person:</strong> Mrs. Indira Kulai - 9742165145
          </p>
        </>
      ),
    },
    {
      name: "Additional Campus",
      image: lakeImg,
      content: (
        <>
          <p>
            Lake View Branch, #18/1, 9th Cross, RBI Layout, J.P Nagar 7th Phase,
            Near Brigade Gardenia, Bangalore - 560078
          </p>
          <p className="mt-2">
            <strong>Phone:</strong> 08026850266
          </p>
          <p className="mt-2">
            <strong>Email:</strong> capitolkids@yahoo.co.in
          </p>
        </>
      ),
    },
    {
      name: "Hegde Nagar Branch",
      image: hegdeImg,
      content: (
        <>
          <p>
            27, Chokkanhalli Main Road, Jakkur Post, Near Bharati City/Sobha
            City, Yelahanka, Bengaluru - 560064
          </p>
          <p className="mt-2">
            <strong>Ph:</strong> 8105994545, 8105564545
          </p>
          <p className="mt-2">
            <strong>Email:</strong> capitolhegdenagar@gmail.com
          </p>
        </>
      ),
    },
  ];

  return (
    <section className="bg-gray-50 py-16 px-6">
      <div className="max-w-7xl mx-auto">

        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-10">
          Contact Us
        </h2>

        {/* Tabs */}
        <div className="flex flex-wrap rounded-xl overflow-hidden mb-6 shadow-md">
          {branches.map((branch, index) => (
            <button
              key={index}
              onClick={() => setActive(index)}
              className={`flex-1 px-6 py-4 font-bold transition ${
                active === index
                  ? "bg-yellow-400 text-white"
                  : "bg-red-600 text-white hover:bg-red-500"
              }`}
            >
              {branch.name}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-10 border flex flex-col md:flex-row gap-6 items-center">

          {/* Text */}
          <div className="md:w-1/2 text-gray-700 text-lg leading-relaxed">
            {branches[active].content}
          </div>

          {/* Image */}
          <div className="md:w-1/2">
            <img
              src={branches[active].image}
              alt="branch"
              className="w-full h-[300px] object-cover rounded-xl shadow"
            />
          </div>

        </div>
      </div>
    </section>
  );
}

export default ContactSection;